import { WritableDraft } from 'immer';

import { ThemePack } from '@/types/theme-packs.types';
import { ContentState } from '../types';

const handleThemePackMutations = (updatedThemePack: ThemePack, state: WritableDraft<ContentState>) => {
  if (state.themePacks?.length) {
    state.themePacks = state.themePacks.map((pack) => {
      if (pack.color_pack === updatedThemePack.color_pack) {
        return updatedThemePack;
      }
      return pack;
    });
  }
};

export default handleThemePackMutations;
